export enum EmpresaTableAction {
  VER = 'VER',
  MODIFICAR = 'MODIFICAR',
}
